import React from 'react'

import Image from 'src/components/image/dynamic'

import * as styles from './keyvisual.module.scss'


const Keyvisual = ({ imagePC, imageSP }) => {

    return (
        <div className={styles.keyvisual}>
            <div>
                <Image imagePC={imagePC} imageSP={imageSP} className={styles.fullsize} />
            </div>
        </div>
    )
}

export default Keyvisual